module.exports = __webpack_public_path__ + "media/dollar.1dfed154.svg";